//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DirUtil } from "@nuskin/ns-util";
import { NsIcon, NsAnimateHeight } from "@nuskin/design-components";
import { fromJsonString, getFullUrl } from "@nuskin/ns-common-lib";

export default {
  name: "NsFooterNav",
  components: { NsIcon, NsAnimateHeight },
  props: {
    /**
     * Display in minimal mode
     */
    minimal: {
      type: Boolean,
      default: false
    },
    /**
     * An array of navigation objects. Each object should contain: title and
     * links with name and href ([{ title, links: [{ name, href }] }])
     */
    navigation: {
      type: [Array, String],
      default() {
        return [];
      },
      validator: value => {
        const nav = fromJsonString(value) || [];
        return (
          Array.isArray(nav) &&
          nav.every(
            item =>
              // has valid title
              item.title &&
              typeof item.title === "string" &&
              // has valid links array
              Array.isArray(item.links) &&
              item.links.every(item =>
                ["name", "href"].every(
                  prop => item[prop] && typeof item[prop] === "string"
                )
              )
          )
        );
      }
    }
  },
  data() {
    return {
      openNavItemTitle: ""
    };
  },
  computed: {
    siteUrl() {
      return this.$NsAppService.siteUrl || "";
    },
    localNavigation() {
      return fromJsonString(this.navigation) || [];
    },
    dir() {
      return DirUtil.getDir();
    }
  },
  methods: {
    handleNavItemClick(title) {
      this.openNavItemTitle = this.openNavItemTitle === title ? "" : title;
    },
    getFullyQualifiedUrl(url) {
      return getFullUrl(this.siteUrl, url);
    }
  }
};
